/* eslint-disable no-console */

// Service worker registration for VitePWA
if (import.meta.env.MODE === "production") {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register(`${import.meta.env.BASE_URL}sw.js`)
        .then((registration) => {
          console.log("SW registered: ", registration);

          // Listen for updates
          registration.addEventListener("updatefound", () => {
            console.log("New content is downloading.");
            const newWorker = registration.installing;

            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "installed") {
                if (navigator.serviceWorker.controller) {
                  // New content is available
                  console.log("New content is available; please refresh.");
                  document.dispatchEvent(
                    new CustomEvent("swUpdated", { detail: registration })
                  );
                } else {
                  // Content is cached for the first time
                  console.log("Content has been cached for offline use.");
                }
              }
            });
          });
        })
        .catch((registrationError) => {
          console.log("SW registration failed: ", registrationError);
        });
    });

    // Listen for offline/online events
    window.addEventListener("online", () => {
      console.log("App is back online.");
    });

    window.addEventListener("offline", () => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
  }
}
